import type { UploadFile } from '../../lib/api';

/** Converts a browser File at the Web boundary into the portable upload DTO. */
export async function toUploadFile(file: File): Promise<UploadFile> {
  return {
    filename: file.name,
    contentType: file.type || undefined,
    bytes: new Uint8Array(await file.arrayBuffer()),
  };
}
